import React from 'react';
import SpotlightHeader from '../../Common/Header';
import BottomBar from '../../../components/BottomBar';
import './Bio.scss';
import { isValidString } from '../../../helpers/utils';
const CELEBRATE_IMAGE = 'https://cdn.upshow.tv/assets/spotlight_creator/celebrate_v2.png';
const Bio = props => {
  var _metadata$boh_bio_inf, _metadata$boh_bio_inf2, _metadata$boh_bio_inf3, _metadata$boh_bio_inf4, _metadata$boh_bio_inf5;
  const {
    metadata,
    bohStyle,
    text
  } = props;
  const {
    accent_color,
    text_accent_color,
    containerStyle
  } = bohStyle;
  const bio_inputs = (_metadata$boh_bio_inf = (_metadata$boh_bio_inf2 = metadata.boh_bio_info) === null || _metadata$boh_bio_inf2 === void 0 ? void 0 : (_metadata$boh_bio_inf3 = _metadata$boh_bio_inf2.inputs) === null || _metadata$boh_bio_inf3 === void 0 ? void 0 : _metadata$boh_bio_inf3.filter(input => isValidString(input.key) && isValidString(input.value))) !== null && _metadata$boh_bio_inf !== void 0 ? _metadata$boh_bio_inf : [];
  const hide_poweredbyupshow = metadata.hide_poweredbyupshow;
  const image = (_metadata$boh_bio_inf4 = metadata.boh_bio_info) === null || _metadata$boh_bio_inf4 === void 0 ? void 0 : _metadata$boh_bio_inf4.image;
  return /*#__PURE__*/React.createElement("div", {
    className: "bio-container",
    style: containerStyle
  }, /*#__PURE__*/React.createElement(SpotlightHeader, {
    text: text,
    metadata: metadata
  }), /*#__PURE__*/React.createElement("div", {
    className: "bio-info-container"
  }, image ? /*#__PURE__*/React.createElement("div", {
    className: "bio-picture-container"
  }, /*#__PURE__*/React.createElement("img", {
    className: "bio-picture",
    src: image,
    alt: "profile"
  })) : /*#__PURE__*/React.createElement("img", {
    className: "bio-celebrate",
    src: CELEBRATE_IMAGE,
    alt: "celebrate"
  }), /*#__PURE__*/React.createElement("div", {
    className: "bio-info"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bio-info-title"
  }, (_metadata$boh_bio_inf5 = metadata.boh_bio_info) === null || _metadata$boh_bio_inf5 === void 0 ? void 0 : _metadata$boh_bio_inf5.title), /*#__PURE__*/React.createElement("div", {
    className: "bio-info-inputs"
  }, bio_inputs.map((i, index) => {
    return /*#__PURE__*/React.createElement("p", {
      key: `input_${index + 1}`
    }, /*#__PURE__*/React.createElement("label", null, i.key, ":", /*#__PURE__*/React.createElement("br", null)), " ", i.value, " ");
  })))), /*#__PURE__*/React.createElement(BottomBar, {
    accent_color: accent_color,
    accent_text_color: text_accent_color,
    hide_poweredbyupshow: hide_poweredbyupshow
  }));
};
export default Bio;